<div class="relative pt-[100%]">
  <div class="absolute inset-0 size-full">
    <app-router-link
      [params]="params()"
      [route]="Route.PL_BoxDetails">
      <app-image-thumbnail
        [rounded]="false"
        size="full">
        <img
          [alt]="imageAlt()"
          [fill]="true"
          [ngSrc]="imageSrc()"
          class="object-contain" />
      </app-image-thumbnail>
    </app-router-link>
  </div>
</div>

<div class="flex flex-col items-center py-3">
  <app-router-link
    [params]="params()"
    [route]="Route.PL_BoxDetails">
    <div class="pt-3 pb-6 uppercase hover:underline">{{ name() }}</div>
  </app-router-link>

  <app-public-cart-add-button
    [sales]="sales()"
    label="Kup box"
    maxWidth="16rem" />
</div>
